import { Button, TextField, Grid } from "@material-ui/core"
import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import { selectClienteTarget, cambiarMensualidadesAction } from "../../../ducks/clientesDuck"
import BackDrop from "../../../global/BackDrop"
import { esFinalizado } from "../../../utils/esFinalizado"

const FMensualidades = () => {
    const { cliente, referencia, verificado } = useSelector(store => store.cliente)
    const [value, setValue] = useState("0")
    const [load, setLoad] = useState(false)
    const [editar, setEditar] = useState(false)
    const dispatch = useDispatch()
    const handleGuardar = () => {
        if (verificado)
            return null

        if (Number(value) <= 0) {
            ToastMessage.fire({
                icon: "warning",
                title: 'Las mensualidades deben de ser mayor o igual a 1',
            })
            return null
        }

        if (Number(value) > 15) {
            ToastMessage.fire({
                icon: "warning",
                title: 'No se pueden agregar mas de 15 meses',
            })
            return null
        }

        DialogMessage.fire({
            title: `Cambio de mensualidades`,
            text: `¿Esta seguro de cambiar el numero de mensualidades para la referencia #${referencia}?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(cambiarMensualidadesAction({
                    IdPaquete: cliente?.paquete?.Id_Paquete,
                    NumeroPagos: value,
                })).then(Response => {
                    setLoad(false)
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    setEditar(false)
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }
    const handleChangeValue = (event) => {
        setValue(event.target.value)
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    return <div>
        <Grid container>
            <Grid item xs={12}>
                <p>Paquete: <b>{cliente?.paquete?.Nombre}</b></p>
                <p>Numero de pagos actual: <b>{cliente?.paquete?.Numero_Pagos}</b></p>
            </Grid>
            <Grid item xs={12}>
                <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <TextField
                        value={value}
                        disabled={verificado || !editar || esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                        style={{ width: "100%" }}
                        id="outlined-number-Cantidad"
                        label="Cantidad"
                        type={verificado || !editar ? "text" : "number"}
                        onChange={handleChangeValue}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            inputProps: { min: 1, max: 15 }
                        }}
                        variant="outlined"
                    />
                    {
                        (!editar) &&
                        <Button
                            style={{ margin: "0 2%" }}
                            variant="contained"
                            color="primary"
                            disabled={verificado || esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                            onClick={hangdleClickEditar}
                        >
                            Editar
                        </Button>
                    }
                    {
                        (editar) &&
                        <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                disabled={verificado}
                                onClick={handleGuardar}
                            >
                                Guardar
                            </Button>
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="default"
                                disabled={verificado}
                                onClick={hangdleClickEditar}
                            >
                                Cancelar
                            </Button>
                        </div>
                    }
                </div>
            </Grid>
        </Grid>
        <BackDrop open={load} />
    </div>
}
export default FMensualidades